//
// Note: The version number is automatically updated when building with Maven.
//

export const version = "0.131";
